import modular from 'modujs';
import * as modules from './modules';
import globals from './globals';
import { html } from './utils/environment';

const app = new modular({
    modules: modules
});

window.onload = (event) => {
    const $style = document.getElementById("stylesheet");

    let isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    window.isMobile = isMobile;

    if(window.isMobile) {
        html.classList.add('is-mobile');
    }

    if ($style.isLoaded) {
        init();
    } else {
        $style.addEventListener('load', (event) => {
            init();
        });
    }
};

function init() {
    // window.addEventListener('resize', () => {
    //     let vw = html.offsetWidth * 0.01;
    //     let vh = window.innerHeight * 0.01;
    //     document.documentElement.style.setProperty('--vw', `${vw}px`);
    //     document.documentElement.style.setProperty('--vh', `${vh}px`);
    // });


    let vw = html.offsetWidth * 0.01;
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    globals();
    app.init(app);

    setTimeout(() => {
        html.classList.add('is-first-loaded');
    }, 50);

    setTimeout(() => {
        html.classList.add('is-loaded');
        html.classList.add('is-ready');
        html.classList.remove('is-loading');
    }, 300);
}
